import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadView3(action) {
  var payload = {
    action: "portal/loadView3",
    url: action.url,
    queryParams: action.queryParams,
  };
  yield put(serverRequest(payload));
}

export default loadView3;
